import script from "./H2Text.vue?vue&type=script&setup=true&lang=js"
export * from "./H2Text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__